import { Component, OnInit, Injector, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { BaseService } from '../../shared/services/base.service';
import { AlertsService } from '../../services/alerts.service';
import { MainComponent } from '../main-component/main.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
@Component({
    selector: 'app-inclusion-exclusion',
    templateUrl: './inclusion-exclusion.component.html',
    styleUrls: ['./inclusion-exclusion.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InclusionExclusionComponent,
            multi: true,
        }],
    standalone: false
})
export class InclusionExclusionComponent extends MainComponent implements ControlValueAccessor, OnInit {
  @Input('value') _value: any;
  @Input() config: any;
  @Input() reload: any;
  propagateChange = (_: any) => { };
  @Output() updateData: EventEmitter<any> = new EventEmitter();
  @Input() form: any;
  container: any = {};
  resources: any = {};
  question: any = {};
  bill_data = [];
  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public modalService: ModalService,
    public baseService: BaseService,
    public alertify: AlertsService
  ) {
    super(injector, route);
  }
  ngOnInit() {
    if (this.config.question != undefined) {
      this.question = this.config.question;
      console.log("form values", this.config.form.value)
    }
    console.log("inclusion-exclusion question", this.question);
    this.getResourcesDefination();
    this.initilizingGrids();
  }
  getResourcesDefination() {
    this.baseService.getResourceDef(this.question.resourcelist[0]['resource'], (resouceDef) => {
      if (resouceDef) {
        this.resources.resouceDef_first = resouceDef;
        this.resources.resouceDef_first.resource = resouceDef.resource;
        if (this.resources.resouceDef_first.list.hasOwnProperty('actions') && this.resources.resouceDef_first.list.actions.length > 0) {
          if (this.resources.resouceDef_first.list.actions[0].conditions[0].hasOwnProperty('datasource')) {
            this.resources.resouceDef_first.add_datasource = this.resources.resouceDef_first.list.actions[0].conditions[0].datasource;
          } else {
            this.resources.resouceDef_first.add_datasource = {};
          }
        }
      }
    });
    this.baseService.getResourceDef(this.question.resourcelist[1]['resource'], (resouceDef) => {
      if (resouceDef) {
        this.resources.resouceDef_second = resouceDef
        this.resources.resouceDef_second.resource = resouceDef.resource;
        if (this.resources.resouceDef_second.list.hasOwnProperty('actions') && this.resources.resouceDef_second.list.actions.length > 0) {
          if (this.resources.resouceDef_second.list.actions[0].conditions[0].hasOwnProperty('datasource')) {
            this.resources.resouceDef_second.delete_datasource = this.resources.resouceDef_second.list.actions[0].conditions[0].datasource;
          } else {
            this.resources.resouceDef_second.delete_datasource = {};
          }
        }
      }
    });
  }
  initilizingGrids() {
    if (this.config) {
      this.container.config_1 = {
        items: [],
        paging: true,
        move_item: false,
        form_controls: this.config.form.value
      };
      this.container.config_2 = {
        items: [],
        paging: true,
        move_item: false,
        form_controls: this.config.form.value
      }
      this.container.show_first = true;
      this.container.show_second = true;
      this.container.initGrid = true;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log("changes", changes, this.config.form);
    if (changes.reload != undefined && changes.reload.currentValue != "") {
      console.log("changes", changes, this.config.form);
      this.container.show_second = false;
      this.container.show_first = false;
      if(this.container.config_2){
        this.container.config_2.form_controls = this.config.form.value ? this.config.form.value : {};
        this.container.config_2.bind_data = true
        this.container.config_2 = JSON.parse(JSON.stringify(this.container.config_2));
      }
      if(this.container.config_1){
        this.container.config_1.form_controls = this.config.form.value ? this.config.form.value : {};
        this.container.config_1 = JSON.parse(JSON.stringify(this.container.config_1));
        this.container.config_1.bind_data = true
      }

      this.container.initGrid = false;
      this.container.show_second = true;
      this.container.show_first = true;
      //setTimeout(()=>{
      this.container.initGrid = true;
      //})
    }
  }
  listen_changes_1(event) {
    if (event.type === 'data_binded') {
      this.container.firstGrid = event.object;
    }
    if (event.type === 'add') {
      this.loader.showSpinner();
      this.moveItem(event);
    }
    if (event.type === 'custom_click') {
      this.loader.showSpinner();
      this.moveItem_(event);
    }
    if (event.type === 'submitted') {
      this.container.config_2.form_controls = this.config.form.value ? this.config.form.value : {};
      this.container.config_2.bind_data = true
      this.container.config_2 = JSON.parse(JSON.stringify(this.container.config_2));

      this.container.config_1.form_controls = this.config.form.value ? this.config.form.value : {};
      this.container.config_1.bind_data = true
      this.container.config_1 = JSON.parse(JSON.stringify(this.container.config_1));
      this.communicationService.hasBillAuthData(true)
    }
    if (event.type == "checkbox") {
      if (event.object && event.object.length > 0) {
        this.value = event.object ? event.object : [];
      }
    }
  }
  listen_changes_2(event) {
    if (event.type === 'data_binded') {
      this.container.config_2.items = event.object;
      // this.bill_data = event.object
    }

    if (event.type === 'add') {
      this.loader.showSpinner();
      this.moveItem(event);
    }
    if (event.type === 'custom_delete') {
      this.removeItem(event);
    }
    if (event.type === 'submitted') {
      this.container.config_2.form_controls = this.config.form.value ? this.config.form.value : {};
      this.container.config_2.bind_data = true
      this.container.config_2 = JSON.parse(JSON.stringify(this.container.config_2));

      if(this.resources.resouceDef_second && this.resources.resouceDef_second.settings && this.resources.resouceDef_second.settings.hitApifirst){
        this.container.config_1.form_controls = this.config.form.value ? this.config.form.value : {};
        this.container.config_1.bind_data = true
        this.container.config_1 = JSON.parse(JSON.stringify(this.container.config_1));
      }
      this.communicationService.hasBillAuthData(true)
    }
    if (event.type === 'field_change') {
      this.container.config_2.items = [];
      for (let d in event.editableGrid) {
        this.container.config_2.items.push(event.editableGrid[d].value)
      }
    }
    if (event.type == "checkbox") {
      if (event.object && event.object.length > 0) {
        this.value = event.object ? event.object : [];
      }
    } else {
      this.value = this.container.config_2.items;
    }
  }
  removeItem(event: any) {
    event.selectedValue.supplierItem.forEach((elem) => {
      event.object.splice(event.object.indexOf(event.object.find(x => x.id == elem.id)), 1);
    })
    this.container.show_second = false;
    this.container.config_2.items = event.object //event.selectedValue.supplierItem//= this.container.config_2.items;
    this.container.show_second = true;
    this.container.config_2.form_controls = event.object ? event.object : {};
    this.container.config_2 = JSON.parse(JSON.stringify(this.container.config_2));
    this.container.config_2.move_item = true;
    // this.container.config_2.bind_data = true;
    this.value = this.container.config_2.items;
  }
  moveItem(data) {
    var duplicateArr
    if (data.button.duplicate_key)
      duplicateArr = this.container.config_2.items.filter(x => x[data.button.duplicate_key] == data.object[data.button.duplicate_key]); // Checking duplicate items
    else
      duplicateArr = this.container.config_2.items.filter(x => x['itemCode'] == data.object['itemCode'])

    if (duplicateArr.length == 0) { // not found duplicate item
      if (this.resources.resouceDef_first && this.resources.resouceDef_first.add_datasource && this.resources.resouceDef_first.add_datasource.resource != undefined) {
        //this.postData(data.object);
        this.ready_data(data.object);
      } else {
        this.container.show_second = false;
        this.container.config_2.items.push(data.object) //= this.container.config_2.items;
        this.container.show_second = true;
        this.container.config_2.form_controls = this.config.form.value ? this.config.form.value : {};
        this.container.config_2 = JSON.parse(JSON.stringify(this.container.config_2));
        this.container.config_2.move_item = true;
        // this.container.config_2.bind_data = true;
        this.container.config_2.items = data.object;
        this.value = this.container.config_2.items;
        console.log("inside move item")
        this.loader.hideSpinner();
      }
    } else {                        // Found duplicate item
      this.alerts.error("Item already added");
      this.loader.hideSpinner();
    }
  }

  moveItem_(data) {
    var duplicateArr
    if (data.button.duplicate_key)
      duplicateArr = this.container.config_2.items.filter(x => x[data.button.duplicate_key] == data.object[data.button.duplicate_key]); // Checking duplicate items
    else
      duplicateArr = this.container.config_2.items.filter(x => x['itemCode'] == data.object['itemCode'])

    if (duplicateArr.length == 0) { // not found duplicate item
      if (this.resources.resouceDef_first && this.resources.resouceDef_first.add_datasource && this.resources.resouceDef_first.add_datasource.resource != undefined) {
        //this.postData(data.object);
        this.ready_data(data.object);
      } else {
        this.bill_data = [...this.bill_data, ...data.selectedValue.supplierItem]
        this.container.show_second = false;
        this.container.config_2.items = this.bill_data//= this.container.config_2.items;
        this.container.show_second = true;
        this.container.config_2.form_controls = this.config.form.value ? this.config.form.value : {};
        this.container.config_2 = JSON.parse(JSON.stringify(this.container.config_2));
        this.container.config_2.move_item = true;
        this.value = this.container.config_2.items;
        console.log("this.value is :: ", this.value);
        this.loader.hideSpinner();
      }
    } else {                        // Found duplicate item
      this.alerts.error("Item already added");
      this.loader.hideSpinner();
    }
  }

  async ready_data(data) {
    let objectLength = Object.keys(data).length;
    if (objectLength > 0) {
      for (const [key, value] of Object.entries(data)) {
        if (value == '' || value == undefined) {
          data[key] = this.config.form.value[key];
        }
      }
      await this.postData(data);
    }
  }
  postData(data) {
    this.baseService.action(data, this.resources.resouceDef_first.add_datasource.action,
      this.resources.resouceDef_first.add_datasource.application, this.resources.resouceDef_first.add_datasource.resource, false).subscribe((res) => {
        console.log("respponse is", res);
        if (res.errCode == 0) {
          this.container.config_2.bind_data = true
          this.container.config_2 = JSON.parse(JSON.stringify(this.container.config_2));
          this.container.initGrid = true;
          this.container.show_second = true;
          this.alerts.success(res.message);
        } else if (res.errCode == -1) {
          this.alerts.error(res.message);
          this.loader.hideSpinner();
        }
      }, (err) => {
        console.log("respponse is", err);
        this.loader.hideSpinner();
      })
  }
  set value(val) {
    // this.container.config_2.items = val;
    this._value = val;
    this.propagateChange(val);
  }
  get value() {
    return this._value;
  }
  writeValue(value) {
    if (value || (this.value != undefined && this.value.length > 0)) {
      this.container.config_2.items = value;
      this.value = this.container.config_2.items;
    }
    else {
      this.container.config_2.items = [];
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  ngDoCheck() {
    //this.loader.hideSpinner()
  }
}